var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrbitCondensed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 31.2941C1.9651 34.7041 11.5194 34.9203 22.3402 31.777C33.1609 28.6338 40.085 22.5088 38.86 19.3664C37.6591 16.4181 32.1083 16.4572 23.7073 18.2094",
    stroke: "url(#paint0_linear_0_1)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2183 26.0742C11.6677 26.0742 9.36982 25.5194 7.32455 24.4097C5.27927 23.2759 3.66712 21.72 2.48808 19.7419C1.3331 17.7638 0.755615 15.5565 0.755615 13.1201C0.755615 10.6837 1.3331 8.47642 2.48808 6.49832C3.66712 4.52023 5.27927 2.97635 7.32455 1.86669C9.36982 0.732908 11.6677 0.166016 14.2183 0.166016C16.7448 0.166016 19.0307 0.732908 21.076 1.86669C23.1213 2.97635 24.7214 4.52023 25.8764 6.49832C27.0313 8.45229 27.6088 10.6596 27.6088 13.1201C27.6088 15.5807 27.0313 17.8 25.8764 19.7781C24.7214 21.732 23.1213 23.2759 21.076 24.4097C19.0307 25.5194 16.7448 26.0742 14.2183 26.0742ZM14.2183 22.8538C16.0711 22.8538 17.7314 22.4316 19.1992 21.5873C20.691 20.743 21.858 19.5851 22.7002 18.1136C23.5664 16.618 23.9995 14.9535 23.9995 13.1201C23.9995 11.2868 23.5664 9.63432 22.7002 8.16282C21.858 6.66719 20.691 5.49722 19.1992 4.65291C17.7314 3.8086 16.0711 3.38645 14.2183 3.38645C12.3655 3.38645 10.6812 3.8086 9.16529 4.65291C7.67345 5.49722 6.49441 6.66719 5.62817 8.16282C4.786 9.63432 4.36492 11.2868 4.36492 13.1201C4.36492 14.9535 4.786 16.618 5.62817 18.1136C6.49441 19.5851 7.67345 20.743 9.16529 21.5873C10.6812 22.4316 12.3655 22.8538 14.2183 22.8538Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 18.359,
    y1: 19.763,
    x2: 21.887,
    y2: 31.9086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFFF",
    stopOpacity: 0.505208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF4BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbitCondensed);
export default __webpack_public_path__ + "static/media/orbitCondensed.99e96fa9fa220dc5d38cb2f22003e01a.svg";
export { ForwardRef as ReactComponent };